import { styled } from '@mui/system';
import { Skeleton } from '@mui/material';
import { Typography } from '@mui/material';

export const RootDiv = styled('div')({
  width: '100%',
  backgroundColor: 'white',
  display: 'flex',
  flexDirection: 'row',
  padding: '12px',
  borderBottom: '1px solid #EAEAEA',
  alignItems: 'center',
  height: '104.5px',
  position: 'relative',
  ':last-child': {
    borderRadius: '0 0 10px 10px',
    borderBottom: 'none',
  },
});

export const ProductQuantity = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '0 20px',
});

export const VerticalLine = styled('hr')({
  height: '104.5px',
  margin: 0,
  border: '1px solid #EAEAEA',
  position: 'absolute',
  marginLeft: '60px',
});

export const ImgDiv = styled('div')({
  display: 'flex',
  width: '80px',
  justifyContent: 'center',
  marginLeft: '30px',
  height: 'inherit',
  alignItems: 'center',
});

export const ImgProduct = styled('img')({
  width: '100%',
  display: 'block',
  objectFit: 'contain',
  maxHeight: '80%',
});

export const SkeletonQuantity = styled(Skeleton)({
  width: '20px',
  height: '20px',
  marginLeft: '10px',
  marginRight: '50px',
});

export const SkeletonImg = styled(Skeleton)({
  width: '5rem',
  height: '5rem',
});

export const SkeletonText = styled(Skeleton)({
  width: '130px',
  height: '80px',
  marginLeft: '16px',
});

export const DetailRootDiv = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: '200px',
  minWidth: '100px',
  paddingBottom: 0,
  padding: '0 10px 0px 12px',
  '@media (min-width: 450px)': {
    flex: 1,
    maxWidth: '90%',
  },
});

export const TitleTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 600,
  fontSize: '13px',
  lineHeight: '19.5px',
  letterSpacing: '0.16px',
  maxWidth: '200px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  color: '#414046',
  '@media (min-width: 450px)': {
    maxWidth: '90%',
  },
});
export const DetailsTextTypography = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  textOverflow: 'ellipsis',
  color: '#757475',
  span: {
    color: '#414046',
  },
});

export const DetailsPriceDiv = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  marginTop: '1px',
});

export const DetailsPriceTypographyBold = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 500,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: '#414046',
});

export const DetailsPriceTypographyLight = styled(Typography)({
  fontFamily: 'Poppins',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0.16px',
  color: '#414046',
});
